/**
 * Creates a fetch wrapper for BoostCore (cookie-based auth).
 * Thin compatibility shim — delegates to the unified apiFetch which handles
 * csrf injection, 401 recovery and login redirect in one place.
 */
export function createBoostCoreFetch(): (input: RequestInfo | URL, init?: RequestInit) => Promise<Response> {
  return async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const { apiFetch } = await import('@/auth/apiFetch')
    return apiFetch(input, init)
  }
}
